import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=108e346c&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"
import style0 from "./vip.vue?vue&type=style&index=0&id=108e346c&prod&lang=css"
import style1 from "./vip.vue?vue&type=style&index=1&id=108e346c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e346c",
  null
  
)

export default component.exports